__turbopack_context__.v({
  "blogNav": "wF98va_blogNav",
});
